import React from "react";
import ExpensesCategoriesComponent from "./ExpensesCategoriesComponent";
import {
  CATEGORY_LIST,
  ADD_CATEGORY,
  UPDATE_CATEGORY_IMAGE,
  DELETE_CATEGORY,
} from "../../Network/ApiPaths";
// import getResponse from "../../Network/GetDataResponse";
// import postDataResponse from "../../Network/PostDataResponse";
import Uri from "../../Network/Uri";
import Pagination from "react-bootstrap-4-pagination";
import postClientDataResponse from "../../Network/PostClientDataResponse";
import getResponseClient from "../../Network/GetClientDataResponse";
import axios from "axios";
let clientHost;
let storeFresh;
class ExpensesCategoriesContainer extends React.Component {
  constructor(props) {
    super();
    const client = window.localStorage.getItem("clientAccess");
    storeFresh = JSON.parse(client);
    if (storeFresh !== null) {
      clientHost = JSON.parse(window.localStorage.getItem("clientAccess")).host;
    }
    this.state = {
      categories: [],
      reset: false,
      test: false,
      cName: "",
      totalRecords: 0,
      livePage: 1,
      addedCat: false,
      editedCat: false,
      selectedCat: [],
      newName: "",
      deletedCatId: "",
      deletedCat: false,
      file: null,
    };
  }

  onNameChange = (e) => {
    this.setState({ cName: e.target.value });
  };
  onNameUpdate = (e) => {
    this.setState({ newName: e.target.value });
  };
  onAdd = (e) => {
    e.preventDefault();
    this.setState({
      test: true,
      reset: true,
      cName: this.state.cName,
    });
    // POST API WITH DATA
    const requestBody = {
      name: this.state.cName,
      addon_status: "NO",
      status: "ACTIVE",
      store_id: storeFresh.storeId,
    };
    postClientDataResponse(
      clientHost + ADD_CATEGORY,
      storeFresh.key,
      requestBody,
      (onSuccessResponse) => {
        this.getCategories();
        this.setState({
          addedCat: true,
        });
      },
      (onError) => {
        console.log(onError.message);
      }
    );
  };
  getCategories = () => {
    var apiPath = new Uri(clientHost + CATEGORY_LIST)
      .addQueryParam("storeid", storeFresh.storeId)
      .addQueryParam("offset", 0)
      .addQueryParam("limit", 10);
    getResponseClient(
      apiPath,
      storeFresh.key,
      (onSuccessResponse) => {
        this.setState({
          reset: false,
          categories: onSuccessResponse.result,
          totalRecords: onSuccessResponse.totalRecords,
        });
      },
      (onError) => {
        console.log(onError.message);
      }
    );
  };
  initiatedEditing = (p) => {
    this.setState({
      selectedCat: p,
    });
  };
  editCat = (c) => {
    if (
      this.state.newName === "" ||
      this.state.newName === this.state.selectedCat.name
    ) {
      alert("no changes to update");
    } else {
      let cid = this.state.selectedCat;
      const requestBody = {
        name: this.state.newName,
        addon_status: "ACTIVE",
        store_id: storeFresh.storeId,
        id: cid.id,
      };
      postClientDataResponse(
        clientHost + ADD_CATEGORY,
        storeFresh.key,
        requestBody,
        (onSuccessResponse) => {
          this.setState({
            editedCat: true,
          });
          this.getCategories();
        },
        (onError) => {
          console.log(onError);
        }
      );
    }
  };
  onChangeCategoryStatus = (p) => {
    // if (p.status === "ACTIVE") {
    //   this.deletePin(p.id);
    // } else {
    // console.log(p);
    // console.log(p.info);

    let requestBody;
    if (p.status === "ACTIVE") {
      requestBody = {
        id: p.id,
        status: "DISABLED",
      };
    } else {
      requestBody = {
        id: p.id,
        status: "ACTIVE",
      };
    }
    postClientDataResponse(
      clientHost + ADD_CATEGORY,
      storeFresh.key,
      requestBody,
      (onSuccessResponse) => {
        this.getCategories();
      },
      (onError) => {
        console.log(onError);
      }
    );
    // }
  };

  onCatTriggerDelete = (e) => {
    this.setState({ deletedCatId: e });
  };
  deleteCat = (dcid) => {
    this.setState({
      deletedCat: true,
    });
    var apiPath = new Uri(clientHost + DELETE_CATEGORY).addQueryParam(
      "id",
      this.state.deletedCatId
    );
    getResponseClient(
      apiPath,
      storeFresh.key,
      (onSuccessResponse) => {
        // this.setState({
        //   deletedCat: true,
        // });
        this.getCategories();
      },
      (onError) => {
        console.log(onError.message);
      }
    );
  };
  convertBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);
      fileReader.onload = () => {
        resolve(fileReader.result);
      };
      fileReader.onerror = (error) => {
        reject(error);
      };
    });
  };
  handleChange = (e, id) => {
    let img = e.target.files[0];
    const handleFileRead = async (event) => {
      const file = img;
      const base64 = await this.convertBase64(file);
      const requestBody = {
        id: id,
        image: base64,
      };
      postClientDataResponse(
        clientHost + UPDATE_CATEGORY_IMAGE,
        storeFresh.key,
        requestBody,
        (onSuccessResponse) => {
          this.getCategories();
        },
        (onError) => {
          console.log(onError.message);
        }
      );
    };
    handleFileRead();
  };
  handleBulk = (e) => {
    let file = e.target.files[0];
    this.setState({ file });
  };
  uploadBulk = () => {
    let file = this.state.file;
    if (file !== null) {
      let formdata = new FormData();
      formdata.append("file", file);
      formdata.append("storeid", storeFresh.storeId);
      axios({
        url: "http://ec2-3-21-71-127.us-east-2.compute.amazonaws.com:8080/api/excel/Items",
        method: "POST",
        data: formdata,
      }).then(
        (res) => {
          console.log(res);
          setTimeout(() => this.getCategories(), 2000);
        },
        (err) => {
          console.log(err);
        }
      );
    } else {
      alert("upload file");
    }
  };
  render() {
    let offsetVal = 0;
    let pagesCount = Math.round(Number(this.state.totalRecords) / 10);
    const { livePage } = this.state;
    let paginationConfig = {
      totalPages: pagesCount,
      currentPage: livePage,
      // currentPage: 1,
      size: "sm",
      onClick: (page) => {
        // alert(page);
        offsetVal = page * 10 - 10;
        var apiPath = new Uri(clientHost + CATEGORY_LIST)
          .addQueryParam("storeid", storeFresh.storeId)
          .addQueryParam("offset", offsetVal)
          .addQueryParam("limit", 10);
        getResponseClient(
          apiPath,
          storeFresh.key,
          (onSuccessResponse) => {
            this.setState({
              categories: onSuccessResponse.result,
              livePage: (offsetVal + 10) / 10,
            });
          },
          (onError) => {
            console.log(onError.message);
          }
        );
      },
    };
    return (
      <>
        <ExpensesCategoriesComponent
          data={this.state.categories}
          nameChange={this.onNameChange}
          handleChange={this.handleChange}
          // handleClick={this.handleClick}
          onNameUpdate={this.onNameUpdate}
          idChange={this.onIdChange}
          add={this.onAdd}
          selectedCat={this.state.selectedCat}
          addedCat={this.state.addedCat}
          update={this.editCat}
          initiatedEditing={this.initiatedEditing}
          editedCat={this.state.editedCat}
          deleteCat={this.deleteCat}
          deletedCat={this.state.deletedCat}
          onCatTriggerDelete={this.onCatTriggerDelete}
          reset={this.state.reset}
          handleBulk={this.handleBulk}
          uploadBulk={this.uploadBulk}
          onChangeCategoryStatus={this.onChangeCategoryStatus}
        />
        <Pagination {...paginationConfig} />
        {/* <Pagination
        totalPages={Math.round(this.state.totalRecords/10,1)}
        currentPage={1}
        showMax={Math.round(this.state.totalRecords/10,1)}
        activeBgColor="#d4515c"
        activeBorderColor="#d4515c"
        color="#d4515c"
      /> */}
      </>
    );
  }
  async componentDidMount() {
    this.getCategories();
  }
}
export default ExpensesCategoriesContainer;
